<template>
  <div class="main-box main-min-height">
    <div class="table-box bgffffff">
      <el-menu :default-active="activeIndex" class="el-menu-demo marginB10" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">未开票</el-menu-item>
        <el-menu-item index="2">已开发票</el-menu-item>
      </el-menu>
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="5">
              <el-form-item prop="date" label="下单时间">
                <DateTime v-model="searchForm.date" format='yyyy-MM-dd' style="width:100%;height:27px" type='daterange' placeholder="-请选择-" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item prop="outTradeNo" label="收货人">
                <el-input v-model="searchForm.outTradeNo" placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="5">
              <el-form-item prop="phone"  label="用户(电话)">
                <el-input v-model="searchForm.phone" clearable placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo">
                  查询
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table">
        <div class="table_content" v-for="(item,index) in tableData" :key="index">
          <div class="info_box">
            <span>订单号:{{item.outTradeNo}}</span>
            <span>付款时间：{{item.successTime}}</span>
          </div>
          <div class="content_box">
            <div style="width:320px" class="flex_c">
              <div class="info_b">
                <img :src="item.headimgUrl" />
                <div class="info_item">
                  <span>姓名：{{item.nickName}}</span>
                  <span>电话：{{item.phoneNumber}}</span>
                </div>
              </div>
            </div>
            <div style="width:150px" class="LR_border flex_c">
              <span>{{item.orderState==1?'待付款':item.orderState==2?'待发货':item.orderState==3?'已取消':item.orderState==4?'退款中':item.orderState==5?'退款成功':item.orderState==6?'退款失败':item.orderState==7?'订单完成':item.orderState==8?'订单待收货':item.orderState==9?'订单待评价':''}}</span>
            </div>
            <div class="LR_border flex_shrink describe" style="flexGrow:2">
              <span>所属商铺:{{item.fullName}}</span>
              <span>抬头类型:{{item.riseType==1?'个人':'企业'}}</span>
              <span>发票抬头：{{item.invoiceRise}}</span>
              <span>税号：{{item.dutyParagraph}}</span>
              <span>邮箱：{{item.mailbox}}</span>
            </div>
            <div class="flex_c" style="width:200px">
              <el-button style="width:90px" type="primary" size="mini" @click="open(item.outTradeNo)">开具发票</el-button>
            </div>
          </div>
        </div>
      </div>
      <Pagination class="bgffffff" location='left' :page='page' @getData="getInfo" />
    </div>
  </div>
</template>

<script>
import DateTime from '@/components/DateTime'
import Pagination from '@/components/pagination/Pagination.vue'
export default {
  name: 'invoice',
  components: {
    DateTime,
    Pagination
  },
  data() {
    return {
      searchForm: {
        date: null,
        beginTime: null, //下单开始时间
        endTime: null, //下单结束时间
        contacts: null, //收货人
        phone: null, //	用户电话
      },//查询条件
       page: { //翻页处理
        currentPage: 1,
        pageSize: 5,
        total: 0,
      },
      tableData: [],//表格参数
      activeIndex: '1',
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    //获取查询信息
    getInfo() {
      this.$Invoice.invoiceManagePage(
        {
          ...this.searchForm,
          state: this.activeIndex,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //切换
    handleSelect(e) {
      this.activeIndex = e;
      this.getInfo()
    },
    open(outTradeNo) {
      this.$Invoice.invoiceManagePage({outTradeNo}).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000)
          this.getInfo()
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
.table {
  width: 100%;
  .table_heder {
    display: flex;
    box-sizing: border-box;
    height: 48px;
    background: #f8f8fe;
    border: 1px solid #eeeeee;
    margin-bottom: 12px;
    > div {
      width: 100px;
      height: 48px;
      line-height: 48px;
      text-align: center;
    }
  }
  .table_content {
    .info_box {
      width: 100%;
      height: 30px;
      background: #f4f4f4;
      display: flex;
      margin-bottom: 10px;
      > span {
        width: 250px;
        font-size: 12px;
        line-height: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #222222;
      }
    }
    .content_box {
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      display: flex;
      > div {
        width: 100px;
        min-height: 48px;
        text-align: center;
      }
    }
  }
}
.flex_shrink {
  flex-shrink: 1;
}
.LR_border {
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
.info_b {
  display: flex;
  box-sizing: border-box;
  height: 88px;
  padding-left: 10px;
  align-items: center;
  > img {
    width: 55px;
    height: 55px;
  }
}
.flex_c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.boeder_tline {
  border-top: 1px solid #eeeeee;
}
.y_color {
  color: #ff702e;
}
.lv_color {
  color: #0acd5e;
}
.info_item {
  display: flex;
  margin-left: 20px;
  flex-direction: column;
  > span:nth-of-type(1) {
    margin-bottom: 10px;
  }
}
.describe{
  display: flex;
  flex-direction: column;
  padding:20px 0px  20px 20px;
  >span{
    margin-bottom: 10px;
    text-align: left;
  }
}
.main-min-height{
  min-height: calc(100vh - 74px);
}
</style>
